import { useState, useEffect, useRef } from 'react';
import './RequirementCheck.css';

const STATUS_ICONS = { ok: '✓', warning: '⚠', missing: '✗' };

export default function RequirementCheck({ status, label, detail }) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open || !detail) return;
    function handlePointerDown(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('pointerdown', handlePointerDown);
    return () => document.removeEventListener('pointerdown', handlePointerDown);
  }, [open, detail]);

  return (
    <div
      ref={wrapperRef}
      data-has-detail={detail ? 'true' : undefined}
      className={`req-check req-check--${status}${open ? ' req-check--open' : ''}`}
    >
      <button
        type="button"
        className="req-check-pill"
        onClick={() => detail && setOpen(o => !o)}
        aria-expanded={detail ? open : undefined}
      >
        <span className="req-check-icon" aria-hidden="true">
          {STATUS_ICONS[status]}
        </span>
        <span className="req-check-label">{label}</span>
      </button>

      {detail && (
        <div className="req-check-detail" role="tooltip">
          {detail}
        </div>
      )}
    </div>
  );
}
